const IconFilters = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6701 11.2201H19.2371C19.6701 11.2201 20 11.5785 19.9794 12C19.9794 12.4426 19.6289 12.7799 19.2165 12.7799H17.6495C17.3196 13.9602 16.268 14.8244 15.0309 14.8244C13.7938 14.8244 12.7423 13.9602 12.4124 12.7799H2.76289C2.3299 12.7799 2 12.4215 2 12C2 11.5574 2.35052 11.2201 2.76289 11.2201H12.4124C12.7629 10.0609 13.8144 9.17564 15.0515 9.17564C16.2887 9.17564 17.3402 10.0398 17.6701 11.2201ZM13.8144 12C13.8144 12.7166 14.3918 13.2646 15.0516 13.2646C15.7113 13.2646 16.2887 12.7166 16.2887 12C16.2887 11.2834 15.7526 10.7354 15.0516 10.7354C14.3505 10.7354 13.8144 11.2834 13.8144 12Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.39175 6.60422H2.76289C2.3299 6.60422 2 6.26698 2 5.82436C2 5.38173 2.35052 5.0445 2.76289 5.0445H4.39175C4.72165 3.86417 5.7732 3 7.01031 3C8.24742 3 9.29897 3.86417 9.62887 5.0445H19.2371C19.6701 5.0445 20 5.38173 20 5.82436C20 6.26698 19.6495 6.60422 19.2371 6.60422H9.62887C9.29897 7.78454 8.24742 8.64871 7.01031 8.64871C5.7732 8.64871 4.72165 7.78454 4.39175 6.60422ZM8.2487 5.82443C8.2487 5.10781 7.67138 4.5598 7.01158 4.5598C6.35179 4.5598 5.77447 5.14996 5.77447 5.82443C5.77447 6.49891 6.31055 7.08907 7.01158 7.08907C7.71262 7.08907 8.2487 6.54106 8.2487 5.82443Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.62887 17.3958H19.2371C19.6701 17.3958 20 17.733 20 18.1756C20 18.6183 19.6495 18.9555 19.2371 18.9555H9.62887C9.29897 20.1358 8.24742 21 7.01031 21C5.7732 21 4.72165 20.1358 4.39175 18.9555H2.76289C2.3299 18.9555 2 18.6183 2 18.1756C2 17.733 2.35052 17.3958 2.76289 17.3958H4.39175C4.72165 16.2155 5.7732 15.3513 7.01031 15.3513C8.24742 15.3513 9.29897 16.2155 9.62887 17.3958ZM5.77447 18.1757C5.77447 18.8923 6.35179 19.4404 7.01159 19.4404C7.67138 19.4404 8.2487 18.8923 8.2487 18.1757C8.2487 17.4591 7.71262 16.9111 7.01159 16.9111C6.31055 16.9111 5.77447 17.4591 5.77447 18.1757Z"
        fill="white"
      />
    </svg>
  );
};

export default IconFilters;
